var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDnldIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-64 0 511 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m181.628906 346.9375c5.859375 5.863281 15.355469 5.859375 21.210938 0l64.265625-64.265625c5.859375-5.855469 5.859375-15.355469 0-21.210937-5.855469-5.859376-15.351563-5.859376-21.210938 0l-38.660156 38.660156v-108.386719c0-8.285156-6.71875-15-15-15-8.285156 0-15 6.714844-15 15v108.386719l-38.660156-38.660156c-5.859375-5.859376-15.355469-5.859376-21.214844 0-5.855469 5.855468-5.855469 15.355468 0 21.210937zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m256.5 385.601562h-128.535156c-8.28125 0-15 6.714844-15 15 0 8.28125 6.71875 15 15 15h128.535156c8.28125 0 15-6.71875 15-15 0-8.285156-6.714844-15-15-15zm0 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m336.832031 0h-224.933593c-3.976563 0-7.792969 1.582031-10.605469 4.394531l-96.398438 96.398438c-2.8125 2.8125-4.394531 6.628906-4.394531 10.605469v353.46875c0 25.988281 21.144531 47.132812 47.132812 47.132812h289.199219c25.914063 0 47.132813-20.953125 47.132813-47.132812v-417.734376c0-25.914062-20.949219-47.132812-47.132813-47.132812zm-223.867187 35.144531v60.1875c0 9.449219-7.683594 17.132813-17.132813 17.132813h-60.1875zm241 429.722657c0 9.332031-7.542969 17.132812-17.132813 17.132812h-289.199219c-9.445312 0-17.132812-7.6875-17.132812-17.132812v-322.398438h65.332031c25.988281 0 47.132813-21.144531 47.132813-47.132812v-65.335938h193.867187c9.335938 0 17.132813 7.546875 17.132813 17.132812zm0 0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnldIcon);
export default __webpack_public_path__ + "static/media/dnld-icon.793b4bdf.svg";
export { ForwardRef as ReactComponent };